import React from 'react';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as moment from 'moment';
import PlayersApi from "../../api/Players";
import { toast } from "react-toastify";
import { imgUrl } from '../../constants';

export default class PlayerForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                name: "",
                id: '',
                birthday: moment(),
                img: null,
                dorsal: ''
            },
            default_image: ''
        };
    }

    componentWillMount(){
        let st = {...this.props.selected}
        st.default_image = st.img
        this.setState({selected: st});
    }

    onDateChange(newDate){
        let state = {...this.state};
        state.selected.birthday = newDate;
        this.setState(state);
    }

    handleFileUpload(files) {
        let state = {...this.state};
        state.selected.img = files
        this.setState(state);
    }

    cancel(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    render(){
        return(
            <div className="columns">
                <div className="column is-2">
                    <img src={imgUrl+this.state.selected.default_image} width="100" height="100"/>
                </div>
                <div className="column is-10">
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Nombre</label>
                        </div>
                        <div className="field-body">
                            <input className="input" type="text" onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Nombre" autoFocus value={this.state.selected.name} onChange={(e) => {
                                let state = {...this.state};
                                state.selected.name = e.currentTarget.value;
                                this.setState(state);
                            }} />
                        </div>
                    </div>
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Fecha nac.</label>
                        </div>
                        <div className="field-body">
                            <Datepicker
                                selected={moment(this.state.selected.birthday)}
                                onChange={(date) => this.onDateChange(date)}
                                showMonthDropdown
                                showYearDropdown
                                className="input"
                                placeholderText="DD/MM/YYYY"
                            />
                        </div>
                    </div>
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Dorsal</label>
                        </div>
                        <div className="field-body">
                            <input className="input" type="text" onKeyPress={(e) => this.handleKeyPress(e)} placeholder="#" value={this.state.selected.dorsal} onChange={(e) => {
                                let state = {...this.state};
                                state.selected.dorsal = e.currentTarget.value;
                                this.setState(state);
                            }} />
                        </div>
                    </div>
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Foto</label>
                        </div>
                        <div className="field-body">
                            <input
                                className="input file_input"
                                type="file"
                                onChange={ (e) => this.handleFileUpload(e.target.files) }
                                accept="image/gif, image/jpeg, image/jpg, image/png"
                            />
                        </div>
                    </div>
                    <div className="columns has-text-right buttons-modal">
                        <div className="column">
                            <button className="button is-success" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                            <button className="button" onClick={() => this.cancel()}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/player/form.js